/**
 * The Query client (D3: TanStack Query owns server state, and only server state).
 *
 * Defaults chosen against this API rather than copied from a tutorial:
 *
 * - **Never retry a 4xx.** `story_not_found` retried three times is three identical
 *   failures and a slower error message; `isRetriable()` in client.ts is the rule.
 * - **`refetchOnWindowFocus` off.** Nothing here goes stale on its own — the story only
 *   changes when *this* client runs a turn, and the turn's commit transition writes the
 *   cache directly (D3). Refetching on every tab focus would spend requests to learn
 *   nothing, and mid-turn it would race the stream.
 */
import { QueryClient } from '@tanstack/react-query';
import { isRetriable } from '@/api/client';

export const MAX_QUERY_RETRIES = 2;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => failureCount < MAX_QUERY_RETRIES && isRetriable(error),
        refetchOnWindowFocus: false,
        staleTime: 30_000,
      },
      mutations: {
        // A mutation is a player pressing a button. Retrying one behind their back is how
        // you get two stories, or two feedback emails.
        retry: false,
      },
    },
  });
}
